var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"slither"}},[_c('router-view')],1),_vm._v(" "),_c('notifications',{attrs:{"group":"not"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }